import React, { useEffect, useState } from 'react'
import st from './ClientOrders.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import Pagination from 'components/UI/Pagination/Pagination'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import { localisationMaster } from 'Localisation/Localisation'
import ClientOrderList from './ClientOrderList/ClientOrderList'
import { superAxiosRequest } from 'axiosApi'
import AsideModalStore from 'Stores/asideModalStore'
import { PAYERS } from 'components/ContentBox/Global/GlobalModalSingle/templates/Pays/ConfirmPayment'
import CancelModal from './CancelModal/CancelModal'
import { useHistory, useParams } from 'react-router-dom'
import Stores from 'Stores'
import { HeaderButton } from 'components/UI/SuperButton/SuperButton'

const initPagination = {
  page: 1,
  limit: 10,
}

const ClientOrders = () => {
  const { clientID } = useParams()
  const [clients, setClients] = useState(null)
  const [filter, updateFilter] = useLocalStorageFilter({})
  const [pagination, setPagination] = useState(initPagination)

  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const history = useHistory()

  const updateRow = (res) => {
    setClients({
      ...clients,
      result: clients.result.map((client) =>
        client.id === res.id ? res : client,
      ),
    })
  }

  const fetchClients = () => {
    const params = {
      ...filter,
      offset: (pagination.page - 1) * pagination.limit,
      limit: pagination.limit,
    }

    if (clientID) {
      params.client_id = clientID
    }

    superAxiosRequest({
      method: 'get',
      link: 'payments/pay_orders',
      params,
    }).then(({ data }) => {
      setClients(data)
    })
  }

  useEffect(() => {
    setClients(null)
    fetchClients()
  }, [filter, pagination, clientID])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      all_transactions: 'All Transactions',
      all_invoices: 'All invoices',
      entries: 'Entries',
      name_email_inn_phone: 'Name, email, INN, phone number',
      status: 'Status',
      amount: 'Amount',
      created_by: 'Who created the invoices',
      order_number: 'Order number',
      payment_method: 'Payment method',
      group_number: 'Group number',
      date: 'Date',
      group_balance_replenishment: 'Group balance replenishment',
      client_name: 'Client name',
      inn: 'INN',
      phone: 'Phone',
      location: 'Location',
      email: 'Email',
      invoice_validity_period: 'Invoice validity period',
      confirmed_by: 'Confirmed by',
      check: 'Check',
      payment_date: 'Payment date',
      bank: 'Bank',
      status_details: 'Details',
      client_profile: 'Client profile',
      paid: 'Paid',
      unpaid: 'Not paid',
      canceled: 'Cancelled',
      order_cancellation: 'Order cancellation',
      order_confirmation: 'Order confirmation',
      search_client_name: 'Search for client name',
      total: 'Total',
      created: 'Created by',
      without_receipt: 'Without a receipt',
      topping_up_balance: "Topping up the company's balance",
      cash: 'Cash',
    },
  })

  const config = [
    {
      nameState: 'name',
      placeholder: translate.name_email_inn_phone,
      type: 'input',
      label: translate.name_email_inn_phone,
    },
    {
      nameState: 'status_order',
      placeholder: translate.status,
      type: 'select',
      label: translate.status,
      values: [
        { id: 'paid', name: translate.paid },
        { id: 'not_paid', name: translate.unpaid },
        { id: 'cancelled', name: translate.canceled },
      ],
    },
    {
      nameState: 'amount',
      placeholder: translate.amount,
      type: 'input',
      label: translate.amount,
    },
    {
      apiLink: 'payments/created_by_order',
      nameState: 'created_by',
      placeholder: translate.created_by,
      type: 'select',
      option_label_key: 'full_name',
      option_value_key: 'user_id',
      sort_key: 'full_name',
      isSearchable: true,
      isSearch: true,
      label: translate.created_by,
    },
    {
      nameState: 'order_id',
      placeholder: translate.order_number,
      type: 'input',
      label: translate.order_number,
    },
    {
      apiLink: 'payments/banks',
      nameState: 'bank',
      label: translate.payment_method,
      placeholder: translate.payment_method,
      type: 'select',
    },
    {
      nameState: 'group_number',
      placeholder: translate.group_number,
      type: 'input',
      label: translate.group_number,
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: translate.date,
    },
  ]

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/pays/client-orders') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const action = (action, e, items) => {
    const actions = new Map([
      [
        'detail_order',
        () => {
          let a = document.createElement('a')
          a.target = '_blank'
          a.href = '/pays/invoice-details/' + items.order_id
          a.click()
        },
      ],
      [
        'cancel_order',
        () => {
          AsideModalStore.activity(
            {
              name: 'groups_edit_comment',
              link: `payments/pay_orders/${items.id}`,
              isResponsive: true,
              is_put: true,
              button: localisationMaster('text_54', 'groups/all-groups'),
              title: `${translate.order_cancellation} ${items.id}`,
              modalBodyComponent: () => <CancelModal />,
              pl_textarea: localisationMaster('text_62', 'groups/all-groups'),
              valid: {
                comment: 'required',
              },
              //onBeforeSubmit: ,
              onSubmitSuccess: (res) => updateRow(res),
            },
            { status_order: 'cancelled' },
          )
        },
      ],
      [
        'confirm_order',
        () => {
          AsideModalStore.activity(
            {
              isResponsive: true,
              title: `${translate.order_confirmation}: ${items.order_id}`,
              type: 'confirmPayment',
              button: localisationMaster('text_54', 'groups/all-groups'),
              valid: {
                bank: 'required',
                receipt_number: 'required',
                paid_location_id: 'required',
              },
              is_put: true,
              link: `payments/pay_orders/${items.id}`,
              payload: {
                order: items,
              },
              client_data: items,
              onBeforeSubmit: async ({ payer_id, ...values }) => {
                const obj = {
                  payment_confirmed: values.payment_confirmed,
                  is_cash: values.is_cash,
                  receipt: values.receipt,
                  ...(!!values.receipt_number && {
                    receipt_number: values.receipt_number,
                  }),
                  bank: values.bank,
                  paid_location_id: values.paid_location_id,
                }
                // Если новый плательщик
                if (payer_id === PAYERS.NEW_PAYER) {
                  const res = await superAxiosRequest(
                    {
                      method: 'post',
                      link: 'accounts/contact_persons',
                    },
                    {
                      email: values.email,
                      first_name: values.first_name,
                      last_name: values.last_name,
                      inn: values.inn,
                      phone: values.phone,
                      who_is_it: values.who_is_it,
                      user: values.user_id,
                    },
                  ).catch(() => {})
                  obj.payer_id = res.data.id
                }
                // Если плательщик - сам клиент
                else if (payer_id === PAYERS.CLIENT_PAYER) {
                  delete obj.payer_id
                }
                // Если выбран плательщик
                else {
                  obj.payer_id = payer_id
                }

                return obj
              },
              onSubmitSuccess: (data) => updateRow(data),
            },
            {
              payment_confirmed: true,
              is_cash: false,
              receipt: true,
              payer_id: PAYERS.CLIENT_PAYER,
              first_name: items.user_name.split(' ')[0],
              last_name: items.user_name.split(' ')[1],
              who_is_it: '',
              user_id: items.user,
              email: items.email,
              phone: items.phone,
              inn: items.inn,
            },
          )
        },
      ],
      [
        'checkOrder',
        () => {
          const apiConf = {
            method: 'get',
            link: `payments/order_status/${items.order_id}`,
          }
          superAxiosRequest(apiConf).then((res) => {
            const result = Object.assign({}, items, res.data.result)
            updateRow(result)
          })
        },
      ],
      [
        'profile_client',
        () => {
          let a = document.createElement('a')
          a.target = '_blank'
          a.href = '/account_clients/' + items.user
          a.click()
        },
      ],
    ])
    return actions.get(action)?.()
  }

  const handleButtonClick = () => {
    history.push(`/reports/client-transactions/${clientID}`)
  }

  const getUniqueUserNames = (clients) => {
    const uniqueUserNames = Array.from(
      new Set(clients?.result?.map((client) => client?.user_name)),
    )
    return uniqueUserNames.join(', ')
  }
  const headerTitle = `${translate.all_invoices}${clientID ? ` : ${getUniqueUserNames(clients)}` : ''}`

  return (
    <div>
      <div className={st.header}>
        <div>
          <PageHeader title={headerTitle}>
            {clientID && (
              <HeaderButton
                hidePlus
                title={translate?.all_transactions}
                onClick={() => {
                  handleButtonClick()
                }}
              />
            )}
          </PageHeader>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, name: text })
              setPagination(initPagination)
              changeTextValue('name', {
                key: 'name',
                label: translate.search_client_name,
                value: text,
              })
            }}
            onClear={() => {
              const { name: text, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'name'),
              )
            }}
            value={filter?.name || ''}
            placeholder={`${translate.search}...`}
            translate={translate}
          />
        </div>
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            getFilterParams={(e) => {
              updateFilter(e)
              setPagination({ ...pagination, page: 1 })
            }}
            config={config}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
            translate={translate}
          />
        )}
      </div>
      <div className={st.conteinerClient}>
        <div className={st.quantityClients}>
          <div>
            {translate.entries}: {clients?._meta?.count_items}
          </div>
          <div className={st.totalSt}>
            {!!filterTextValues.length && (
              <>
                {translate.total}:
                <div className={st.totalAmount}>
                  {Stores.cleanSumm(clients?._meta?.total_amount / 100) + ' ₸'}
                </div>
              </>
            )}
          </div>
        </div>
        <div>
          {clients?.result?.map((client, index) => (
            <ClientOrderList
              translate={translate}
              key={client.id}
              client={client}
              index={index}
              action={action}
            />
          ))}
        </div>
      </div>
      <div className={st.pagination}>
        {clients?._meta?.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={clients?._meta?.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default observer(ClientOrders)
